import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../AccountForm.meta';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useAccountFormContext } from '../../context/useAccountFormContext';

export const AnnuityDistributionOption = () => {
  const formBag = useFormContext<FormFields>();

  const {
    options: { DistributionOptionOptions },
  } = useAccountFormContext();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.AnnuityDistributionOption"
      render={({ field: { value, onChange, ...field } }) => (
        <Select
          {...field}
          value={DistributionOptionOptions.filter(option => option.value === value)}
          options={DistributionOptionOptions}
          onChange={opt => {
            onChange(opt?.value);
          }}
          label="Distribution Option"
          placeholder="Distribution Option"
          isPortal
        />
      )}
    />
  );
};
